import { Fragment, useEffect, useRef, useState } from 'react';

import Link from 'next/link';

import { XCircleIcon } from '@heroicons/react/24/outline';
import { Dialog, DialogContent, DialogOverlay } from '@reach/dialog';

import { CloseIcon, Logo, MenuIcon, NavGithubLogo } from '@/components/icons/ElementIcons';
import { KomodoWalletBtnNav } from '@/components/shared/KomodoWalletBtnNav';
import MobileSuperNavItem from '@/components/shared/MobileSuperNavItem';
import SuperNavDropdown from '@/components/shared/SuperNavDropdown';

import { inter } from '@/styles/fonts';

import superNavData from '@/data/SuperNavData.json';

const langDropdownData = {
  title: 'En',
  items: [
    {
      title: 'English',
      link: '/',
    },
    {
      title: 'Pусский',
      link: 'https://blog.komodoplatform.com/ru/',
    },
    {
      title: 'Español',
      link: 'https://blog.komodoplatform.com/es/',
    },
  ],
};

export const SuperNav = () => {
  let [isSuperNavOpen, setIsSuperNavOpen] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const closeModalIfClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        closeModal();
      }
    };
    document.addEventListener('mousedown', closeModalIfClickOutside);

    return () => {
      document.removeEventListener('mousedown', closeModalIfClickOutside);
    };
  }, []);

  function closeModal() {
    setIsSuperNavOpen(false);
  }
  function openModal() {
    setIsSuperNavOpen(true);
  }
  return (
    <header className='relative z-[10000] w-full border-b-2 border-blue-400 text-white transition-all'>
      <div
        className='container relative mx-auto px-4 py-4 transition-all xs:px-8 sm:px-6 md:py-9 lg:px-8 lg:py-4 xl:px-12'
        id='nav-padding-div'
      >
        <nav className='flex w-full items-center justify-between text-white'>
          <div className='flex flex-row items-center'>
            <Link href='/' aria-label='Gleec logo' className='mr-4'>
              <Logo />
            </Link>
            {/* {superNavData.map((item: any, index: number) => {
              return <SuperNavDropdown dropDownData={item} key={index} />;
            })}
            <Link
              href='/contact/'
              className='hidden px-2 py-2 mt-1 font-medium text-white hover:text-gray-300 lg:block'
            >
              Contact
            </Link> */}
          </div>
          <div className='mt-3 hidden items-center py-2 lg:col-span-15 lg:mx-auto lg:mt-0 lg:flex lg:py-0 lg:text-base xl:col-span-10 xl:text-lg'>
            <Link
              href='/developer/'
              className='mt-1 hidden px-2 py-2 font-medium text-white hover:text-gray-300 lg:block'
            >
              Developer
            </Link>
            {/* Ghost sits beside this app, not inside it: a plain anchor keeps
                next/link from prefixing the basePath. */}
            <a
              href='/blog/'
              className='mt-1 hidden px-2 py-2 font-medium text-white hover:text-gray-300 lg:block'
            >
              News
            </a>
            <Link
              href='/downloads/'
              className='mt-1 hidden px-2 py-2 font-medium text-white hover:text-gray-300 lg:block'
            >
              Downloads
            </Link>
          </div>
          <div className='hidden flex-row items-center lg:flex'>
            <Link href='https://github.com/GLEECBTC/' target='_blank'>
              <NavGithubLogo className='mr-4 h-8 w-8 duration-300 hover:-translate-y-2' />
            </Link>
            <KomodoWalletBtnNav />
            {/* <NavDropdown dropDownData={langDropdownData} /> */}
          </div>
          <div className='block lg:hidden'>
            <button
              type='button'
              onClick={openModal}
              className='relative'
              aria-label='Open navigation'
            >
              <MenuIcon className='h-6 w-6 stroke-slate-500' />
            </button>
            <Dialog isOpen={isSuperNavOpen} onDismiss={closeModal}>
              <div className=''>
                <div className='fixed inset-0 bg-black bg-opacity-70' />
                <div className='fixed inset-0'>
                  <div className='relative z-[10000] w-full transition-all'>
                    <div className='container relative mx-auto max-h-[95%] overflow-y-auto rounded-2xl bg-slate-900 px-4 py-4 shadow-xl transition-all xs:px-8 sm:px-6'>
                      <div
                        ref={ref}
                        className={`transform pb-4 text-left align-middle font-sans text-white transition-all`}
                      >
                        <div className='flex w-full flex-row items-center justify-between'>
                          <Link href='/' aria-label='Gleec logo' className='mr-4'>
                            <Logo />
                          </Link>

                          <button
                            type='button'
                            className='text-blue-200 hover:text-blue-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2'
                            onClick={closeModal}
                          >
                            <XCircleIcon className='h-8 w-8' />
                          </button>
                        </div>
                        <ul className='mt-4 space-y-1'>
                          <li className='pb-4'>
                            <Link
                              href='/developer/'
                              onClick={closeModal}
                              className='px-2 text-lg font-medium'
                            >
                              Developer
                            </Link>
                          </li>
                          {/* <li className='pb-4'>
                            <Link href='#' className='px-2 text-lg font-medium'>
                              White paper
                            </Link>
                          </li> */}
                          <li className='pb-4'>
                            {/* Plain anchor: Ghost is outside the basePath. */}
                            <a
                              href='/blog/'
                              onClick={closeModal}
                              className='px-2 text-lg font-medium'
                            >
                              News
                            </a>
                          </li>
                          <li className='pb-4'>
                            <Link
                              href='/downloads/'
                              onClick={closeModal}
                              className='px-2 text-lg font-medium'
                            >
                              Downloads
                            </Link>
                          </li>
                          {/* {superNavData.map((item: any, index: number) => {
                            return (
                              <MobileSuperNavItem
                                catName={item.title}
                                items={item.items}
                                key={index}
                              />
                            );
                          })} */}
                          {/* <li className="pb-4">
                            <Link
                              href="/contact/"
                              className="px-2 text-lg font-medium"
                            >
                              Contact
                            </Link>
                          </li> */}
                          <li className='pb-4'>
                            <Link
                              href='https://github.com/GLEECBTC/'
                              target='_blank'
                              className='flex flex-row items-center px-2'
                              onClick={closeModal}
                            >
                              <NavGithubLogo className='h-6 w-6' />
                              <span className='ml-2 text-lg font-medium'>Github</span>
                            </Link>
                          </li>
                          <li onClick={closeModal}>
                            <KomodoWalletBtnNav />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Dialog>
          </div>
        </nav>
      </div>
    </header>
  );
};
